<template>
	<div class="carlinebg">

		<div class="caelinedtop">
			<p>{{cardetail.MDHNAME1}}</p>
			<div class="cartopbanner">
				<el-image style="" :src="url" fit="contain"></el-image>
			</div>
			<div class="cartoppic row f-c">
				<el-image style="width: 122px; height: 80px" v-for="(url,index) in pics" :key="index" :src="url"
					fit="contain" @click="changebanner(url)">
				</el-image>
			</div>
		</div>
		<div class="carlined">
			<div class="carlinedtime">
				<p>{{titleTime}}</p>
				<div class="carlinebox">
					<el-button :class="cardetail.MDTTHOUR=='true'?'carlinetime timenormal':'carlinetime timenoact'"
						@click="clickpop(0)" :disabled="cardetail.MDTTHOUR=='true'?false:true">
						<p>3<span>h</span></p>
						<span>{{$t('carlinedetail.carline_17')}}</span>
					</el-button>
					<el-button :class="cardetail.MDTSHOUR=='true'?'carlinetime timenormal':'carlinetime timenoact'"
						@click="clickpop(1)" :disabled="cardetail.MDTSHOUR=='true'?false:true">
						<p>6<span>h</span></p>
						<span>{{$t('carlinedetail.carline_17')}}</span>
					</el-button>
					<el-button :class="cardetail.MDTNHOUR=='true'?'carlinetime timenormal':'carlinetime timenoact'"
						@click="clickpop(2)" :disabled="cardetail.MDTNHOUR=='true'?false:true">
						<p>9<span>h</span></p>
						<span>{{$t('carlinedetail.carline_17')}}</span>
					</el-button>
					<el-button :class="cardetail.MDTTRHUR=='true'?'carlinetime timenormal':'carlinetime timenoact'"
						@click="clickpop(3)" :disabled="cardetail.MDTTRHUR=='true'?false:true">
						<p>24<span>h</span></p>
						<span>{{$t('carlinedetail.carline_17')}}</span>
					</el-button>
				</div>
				<!-- <div class="clend row f-b" @click="clickpop()">
					<div class="clendbox">
						Calender<span>{{$t('carlinedetail.carline_1')}}</span>
					</div>
					<img src="@/assets/default/calendatJT.png" alt="">
				</div> -->
			</div>
			<div class="carspec">
				<div class="carspectitle">SPEC</div>
				<div class="carspecitem row f-b">
					<span>{{$t('carlinedetail.carline_2')}}</span>
					<span v-if="cardetail.MDTJLIMT">{{cardetail.MDTJLIMT}}{{$t('bc.bc_21')}}</span>
					<span v-else>-</span>
				</div>
				<div class="carspecitem row f-b">
					<span>{{$t('carlinedetail.carline_3')}}</span>
					<span v-if="cardetail.MDTJTASM">{{cardetail.MDTJTASM}}</span>
					<span v-else>-</span>
				</div>
				<div class="carspecitem row f-b">
					<span>{{$t('carlinedetail.carline_4')}}</span>
					<span v-if="cardetail.MDTJHAND">{{cardetail.MDTJHAND}}</span>
					<span v-else>-</span>
				</div>
				<div class="carspecitem row f-b">
					<span>{{$t('carlinedetail.carline_5')}}</span>
					<span v-if="cardetail.MDTJEMSN">{{cardetail.MDTJEMSN}}{{$t('bc.bc_22')}}</span>
					<span v-else>-</span>
				</div>
				<div class="carspecitem row f-b">
					<span>{{$t('carlinedetail.carline_6')}}</span>
					<span v-if="cardetail.MDTJOUTP">{{cardetail.MDTJOUTP}}{{$t('bc.bc_23')}}</span>
					<span v-else>-</span>
				</div>
				<div class="carspecitem row f-b">
					<span>{{$t('carlinedetail.carline_7')}}</span>
					<span v-if="cardetail.MDTJCFTB">{{cardetail.MDTJCFTB}}{{$t('bc.bc_21')}}</span>
					<span v-else>-</span>
				</div>
				<div class="carspecitem row f-b">
					<span>{{$t('carlinedetail.carline_8')}}</span>
					<span v-if="cardetail.MDTJDRIV">{{cardetail.MDTJDRIV}}</span>
					<span v-else>-</span>
				</div>
				<div class="carspecitem row f-b">
					<span>{{$t('carlinedetail.carline_9')}}</span>
					<span v-if="cardetail.MDTJSIZE">{{cardetail.MDTJSIZE}}</span>
					<span v-else>-</span>
				</div>
				<div class="carspecitem row f-b">
					<span>{{$t('carlinedetail.carline_10')}}</span>
					<span v-if="cardetail.MDTJEQPM">{{cardetail.MDTJEQPM}}</span>
					<span v-else>-</span>
				</div>
			</div>
		</div>
		<div class="carlinedbot" v-if="cardetail.MDTCOMNT">
			<p>{{$t('carlinedetail.carline_11')}}</p>
			<div class="carlinedbotbox">
				{{cardetail.MDTCOMNT}}
			</div>
		</div>
		<div class="carlinbn row f-b"  @click="btncarline=='1' ? clickpop():''" :style="btncarline=='1' ? 'background: #FF9C00;' :'background: #DDDDDD;cursor: not-allowed;'" >

			<div class="btntext" >
				{{$t('carlinedetail.carline_14')}}
			</div>
			<div>
				<img src="@/assets/default/calendatJT.png" alt="">
			</div>

		</div>

		<!-- 未登录时弹窗 -->
		<div class="carlogin" v-show="popshow">
			<div class="carloginitem">
				<img src="@/assets/default/close.png" alt="" @click="clickpop()">
				<div class="carloginlist">
					<el-image style="" :src="loginpic" fit="contain"></el-image>
					<p></p>
					<div class="carloginbox orangebg row f-b" @click="toLogin">

						<div class="carloginboxtext" @click="toLogin">
							{{$t('carlinedetail.carline_16')}}
						</div>

						<div>
							<img src="@/assets/default/calendatJT.png" alt="">
						</div>
						<!-- 	<p @click="toLogin">{{$t('carlinedetail.carline_16')}}</p> -->



					</div>
					<div class="carloginbox whitebg row f-b" @click="ReserveCar()">

						<div class="carloginboxtext">
							{{$t('carlinedetail.carline_15')}}
						</div>
						<!-- <p></p> -->
						<div>
							<img src="@/assets/default/enter.png" alt="">
						</div>
					</div>
				</div>
			</div>
		</div>
	</div>
</template>

<script>
	export default {
		name: 'CarLineDetail',
		components: {

		},
		data() {
			return {
				url: '',
				pics: [],
				popshow: false,
				curTime: '',
				timedata: '',
				titleTime: '',
				carid: '',
				tid: '',
				carlinlist: [],
				cardetail: {},
				three: '',
				six: '',
				nine: '',
				ersi: '',
				personnum: '',
				addday: '',
				time: '',
				loginpic: '',
				weekday:'',
				lang:0
			};
		},
		watch: {},
		computed: {},
		methods: {

			Get_Car_BYID() {
				if (this.$i18n.locale == 'ja') {
					this.lang = 0
				}
				else if (this.$i18n.locale == 'zh') {
					this.lang = 1
				}
				else if (this.$i18n.locale == 'en') {
					this.lang = 2
				}
				this.$api.post(this.$config.Get_Car_BYID, {
						'sDate': this.curTime,
						'sLNGCT': this.lang,
						'sMDHID': this.carid,
						'sWeekday':this.weekday,
					},
					// 请求成功
					success => {

						console.log(success.KKDT)

						this.cardetail = success.KKDT[0]
						this.carlinlist = success.KKDT
						this.pics = success.KKDT.map((item, index) => {
							return item.MDQMLINK
						})
						let textjs = '0.'
						this.url = this.carlinlist.filter(item => item.MDQIMGNM.indexOf(textjs) != -1)[0].MDQMLINK
						this.loginpic = this.carlinlist.filter(item => item.MDQIMGNM.indexOf(textjs) != -1)[0].MDQMLINK
						this.three = success.KKDT[0].MDTTHOUR
						this.six = success.KKDT[0].MDTSHOUR
						this.nine = success.KKDT[0].MDTNHOUR
						this.ersi = success.KKDT[0].MDTTRHUR
						this.personnum = success.KKDT[0].MDTJLIMT
						this.addday = success.KKDT[0].MDTADDAY
						
						if(this.three=='false' && this.six=='false' && this.nine=='false' && this.ersi=='false'){
							this.btncarline = "0";
						}else{
							this.btncarline = "1";
						}
					},
					// 请求失败
					error => {
						console.log(error)
					}
				)
			},
			changebanner(index) {
				console.log(index)
				this.url = index
			},
			clickpop(time) {
				this.time = time
				if (sessionStorage.getItem("log_email")) {
					this.ReserveCar()
				} else(
					this.popshow = !this.popshow
				)
			},
			toLogin() {
				this.$parent.$refs["headview"].dialogLoginVisible = true;
				this.$parent.$refs["headview"].dialogResetVisible = false;

				this.$parent.$refs["headview"].dialogRegisterVisible = false;

				this.popshow = false;
			},
			ReserveCar() {
				// this.$router.push('/ReserveCar')
				// 	 this.$router.push({
				// 	        path: '/ReserveCar',
				// 	        query: {
				// 	          cardNoFirst: row.cardNoFirst,
				// 	          cardNoEnd: row.cardNoEnd
				// 	        }// 要传递的参数
				// 	      })
				// 	    }
				// if (this.time) {
				// 	this.time = this.time + 'h（¥18,000）'
				// }
				// console.log(this.time)
				this.$router.push({
					path: 'ReserveCar',
					query: {
						// tid: this.tid,
						linecarid: this.carid,
						// types: this.time,
						// timedata: this.timedata,
						// three: this.three,
						// six: this.six,
						// nine: this.nine,
						// ersi: this.ersi,
						// personnum: this.personnum,
						// addday:this.addday,
						curTime: this.curTime,
						weekday: this.weekday
						// titleTime: this.titleTime
					} // 要传递的参数
				})
				let flag = 0;
				if (this.addday.toString() == 'false') {
					flag = '1' //禁用
				}

				let carform = {
					types: this.time,
					three: this.three,
					six: this.six,
					nine: this.nine,
					ersi: this.ersi,
					personnum: this.personnum,
					addday: this.addday,
					dayflag: flag
				}
				sessionStorage.setItem("carform", JSON.stringify(carform));

				console.log(carform)

				console.log(this.curTime)
			}



		},
		created() {

			console.log(this.$route.query)
			this.carid = this.$route.query.carid;
			this.curTime = this.$route.query.curTime;
            this.weekday = this.$route.query.weekday;
			// this.tid = this.$route.query.tid;
			// this.timedata = this.$route.query.timedata;
			// this.titleTime = this.$route.query.titleTime;
		},
		mounted() {
			this.Get_Car_BYID()
		}
	}
</script>

<style scoped>
	@media only screen and (min-width:680px) {
		.carlinebg {
			width: 76%;
			margin: 0 auto
		}

		.cartopbanner>.el-image {
			width: 100%;
			height: 560px;
			margin: 0
		}

		.caelinedtop {
			font-size: 40px;
			font-family: Roboto-Bold, Roboto;
			padding-top: 70px
		}

		.carlined {
			margin: 0 auto;
			margin-top: 30px;
			width: 84%;
			display: flex;
			flex-direction: row;
			justify-content: space-between;
		}

		.carlinedtime {
			width: 40%
		}

		.carspec {
			width: 46%;
		}

		.carloginitem {
			width: 640px;
			margin: 0 auto;
			border-radius: 6px;
			background-color: #fff;
		}

		.carloginlist {
			padding: 40px 90px;
			width: 100%
		}

		.carloginlist .el-image {
			width: 460px;
			height: 274px;
			margin: 0;
		}

		.carloginbox {
			width: 46%;
			margin: 0 auto;
			height: 50px;
			line-height: 50px;
			padding: 0 10px;
			box-sizing: border-box;
			margin-bottom: 15px;
			cursor: pointer;
		}

		.carloginboxtext {
			width: calc(100% - 18px);
			font-size: 18px;
			font-family: Noto Sans CJK JP-Bold, Noto Sans CJK JP;
		}

		.carlinbn {
			margin: 60px auto;
			width: 50%;
			height: 60px;
			background: #FF9C00;
			line-height: 60px;
			padding: 0 10px;
			box-sizing: border-box;
			cursor: pointer;
		}

		.btntext {
			width: calc(100% - 16px);
			text-align: center;
			font-size: 24px;
			font-family: Noto Sans CJK JP-Bold, Noto Sans CJK JP;
			color: #fff
		}
	}

	@media only screen and (max-width:680px) {
		.carlinebg {
			width: 100%;
			margin: 0 auto;
			padding: 0 4%;
			box-sizing: border-box;
		}

		.cartopbanner>.el-image {
			width: 100%;
			height: auto;
			display: block;
			margin: 0
		}

		.caelinedtop {
			font-size: 28px;
			font-family: Roboto-Bold, Roboto;
			padding-top: 40px
		}

		.carlined {
			margin: 0 auto;
			margin-top: 10px;
			width: 84%;
		}

		.carspec {
			margin-top: 20px;
		}

		.carloginitem {
			width: 80%;
			margin: 0 auto;
			border-radius: 6px;
			background-color: #fff;
		}

		.carloginlist {
			padding: 40px 5%;
			width: 100%;
			box-sizing: border-box;
		}

		.carloginlist .el-image {
			width: 100%;
			margin: 0;
		}

		.carloginbox {
			width: 64%;
			margin: 0 auto;
			height: 50px;
			line-height: 50px;
			padding: 0 10px;
			box-sizing: border-box;
			margin-bottom: 15px;
			cursor: pointer;
		}

		.carloginboxtext {
			width: calc(100% - 18px);
			font-size: 15px;
			font-family: Noto Sans CJK JP-Bold, Noto Sans CJK JP;
		}

		.carlinbn {
			margin: 60px auto;
			width: 55%;
			height: 60px;
			background: #FF9C00;
			line-height: 60px;
			padding: 0 10px;
			box-sizing: border-box;
			cursor: pointer;
		}

		.btntext {
			width: calc(100% - 16px);
			text-align: center;
			font-size: 24px;
			font-family: Noto Sans CJK JP-Bold, Noto Sans CJK JP;
			color: #fff
		}
	}

	@media only screen and (max-width:490px) {
		.btntext {
			font-size: 20px;
		}
	}

	@media only screen and (max-width:420px) {
		.btntext {
			font-size: 17px;
		}
	}

	.carlinebox {
		display: flex;
		flex-direction: row;
		justify-content: space-between;
	}

	.row {
		display: flex;
		flex-direction: row;
	}

	.f-c {
		justify-content: center;
	}

	.f-b {
		justify-content: space-between;
	}


	.caelinedtop>p {
		margin-bottom: 30px
	}

	.cartoppic {
		margin-top: 16px;
		cursor: pointer;
	}

	.el-image {
		margin: 0 5px
	}


	.carlinetime {
		width: calc((100% - 30px) / 4);
		border-radius: 6px;
		text-align: center;
		padding-top: 5px;
		font-family: Roboto-Bold, Roboto;
		padding-bottom: 6px
	}

	.carlinetime {
		cursor: pointer;
	}

	.carlinetime p {
		font-size: 28px;
		height: 34px;
		line-height: 34px
	}

	.carlinetime p>span {
		font-size: 16px;
	}

	.carlinetime>span {
		font-size: 10px;
		font-family: Noto Sans CJK JP-Bold, Noto Sans CJK JP;
	}

	.timeactive {
		background-color: #FF9C00;
		color: #000;
	}

	.timenormal {
		background-color: #000;
		color: #fff;
	}

	.timenoact {
		background-color: #DDDDDD;
		color: #fff;
	}


	.carlinedtime>p {
		font-size: 20px;
		font-family: Roboto-Bold, Roboto;
		margin-bottom: 6px
	}

	.cartimetext {
		font-size: 12px;
		color: #D10000;
		margin-top: 12px;
		height: 34px;
		line-height: 17px;
		font-family: Noto Sans CJK JP-Medium, Noto Sans CJK JP;
	}

	.clend {
		width: 100%;
		height: 60px;
		line-height: 60px;
		margin-top: 30px;
		background-color: #000000;
		color: #fff;
		padding: 0 10px;
		box-sizing: border-box;
		font-size: 24px;
		font-family: Roboto-Bold, Roboto;
	}

	.clendbox>span {
		font-size: 11px;
		font-family: Noto Sans CJK JP-Bold, Noto Sans CJK;
		margin-left: 8px
	}

	.clend>img {
		width: 14px;
		height: 14px;
		display: block;
		margin-top: 23px
	}


	.carspectitle {
		margin-bottom: 5px;
		font-size: 20px;
		font-family: Roboto-Bold, Roboto;
	}

	.carspecitem {
		height: 28px;
		line-height: 28px;
		border-bottom: 1px solid #DDDDDD;
		font-size: 12px;
		font-family: Noto Sans CJK JP-Bold, Noto Sans CJK JP;
		font-weight: bold;
	}

	.carlinedbot {
		width: 72%;
		margin: 0 auto;
		margin-top: 28px;
	}

	.carlinedbot>p {
		border-bottom: 1px solid #ddd;
		font-size: 12px;
		font-family: Noto Sans CJK JP-Bold, Noto Sans CJK JP;
		line-height: 30px;
		margin-bottom: 8px;
	}

	.carlinedbotbox {
		font-size: 12px;
		font-family: Noto Sans CJK JP-Medium, Noto Sans CJK JP;
		line-height: 26px
	}



	.carlinbn img {
		width: 14px;
		height: 14px;
		display: block;
		margin-top: 23px;
	}

	.carlogin {
		width: 100%;
		height: 100%;
		position: fixed;
		top: 0;
		left: 0;
		background-color: rgba(221, 221, 221, 0.8000);
		overflow: hidden;
		display: flex;
		align-items: center;
		text-align: center;
		justify-content: center
	}


	.carloginitem>img {
		width: 22px;
		height: 48px;
		float: right;
		margin-right: 15px
	}

	.carloginlist>p {
		font-size: 14px;
		font-family: Noto Sans CJK JP-Bold, Noto Sans CJK JP;
		margin: 20px 0
	}


	.carloginbox img {
		width: 14px;
		height: 14px;
		display: block;
		margin-top: 18px;
	}


	.orangebg {
		background: #FF9C00;
		color: #fff
	}

	.whitebg {
		background-color: #fff;
		border: 1px solid #ddd;
		color: #666;
	}


	/deep/ .login .el-dialog__body {

		background-color: #FE9C2C;
	}

	/deep/ .login .el-dialog__header {
		background-color: #FE9C2C;
	}

	/deep/ .login .el-icon-close:before {
		font-size: 20px;
		color: #000000;
	}

	/deep/ .el-button+.el-button {
		margin: 0;
		padding: 0
	}

	/deep/ .el-button {
		padding: 6px 0
	}

	/deep/ .el-button.is-disabled,
	.el-button.is-disabled:focus,
	.el-button.is-disabled:hover {
		background-color: #bbb;
		color: #fff;
	}
</style>
